module.exports = __webpack_public_path__ + "static/paper-blue-efca30c0312faca77c85a6897f9e2efe.webp";